// «Склад: N новых позиций в минусе» (уведомление kind = stock, data_service/notifications/stock.py): позиции
// из payload (до 20) — новых запросов нет. «Открыть склад» — вкладка «Склад» «Себестоимости» (при необходимости
// сначала переключает активный сервер на сервер уведомления).
import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchActiveServer, setActiveServer } from '../../services/serverService';
import { CARD_LABEL_COLOR, DIVIDER_COLOR, MUTED_TEXT_COLOR, PRESS_SX, SECTION_ACCENTS } from '../../styles/tokens';
import { extractErrorMessage } from '../../utils/errors';
import { formatQuantity } from '../../pages/Cost/utils/stockModel';

const ACCENT = SECTION_ACCENTS['/cost'];
const NEGATIVE_COLOR = '#ef6b6b';
const STOCK_URL = '/cost?tab=stock';

export default function StockNegativeDetails({ item, onClose }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const payload = item.payload || {};
  const items = payload.items || [];
  const rest = (payload.count || items.length) - items.length;

  const openStock = async () => {
    setBusy(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      let active = null;
      try {
        active = JSON.parse(localStorage.getItem('activeServer') || 'null');
      } catch {
        active = null;
      }
      if (item.server_id && active?.id !== item.server_id) {
        await setActiveServer(item.server_id, token);
        await fetchActiveServer(token);
      }
      onClose();
      navigate(payload.url || STOCK_URL);
    } catch (err) {
      setError(extractErrorMessage(err));
      setBusy(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {payload.server_name && (
        <Typography sx={{ fontSize: '14px', color: CARD_LABEL_COLOR, mt: -1 }}>{payload.server_name}</Typography>
      )}
      {items.length > 0 ? (
        <Box component="ul" aria-label="Новые позиции в минусе" sx={{ m: 0, p: 0, listStyle: 'none' }}>
          {items.map((position, index) => (
            <Box
              component="li"
              key={`${position.store}-${position.name}-${index}`}
              sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 1.5, py: 0.75, borderTop: index ? `1px solid ${DIVIDER_COLOR}` : 'none' }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: '14px', color: '#fff', overflowWrap: 'anywhere' }}>{position.name}</Typography>
                {position.store && <Typography sx={{ fontSize: '12px', color: MUTED_TEXT_COLOR }}>{position.store}</Typography>}
              </Box>
              <Typography sx={{ flexShrink: 0, fontSize: '14px', fontWeight: 700, color: NEGATIVE_COLOR, fontVariantNumeric: 'tabular-nums' }}>
                {formatQuantity(position.quantity, position.unit)}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography sx={{ fontSize: '14px', color: '#e4e4e7' }}>{item.body}</Typography>
      )}
      {rest > 0 && <Typography sx={{ fontSize: '13px', color: MUTED_TEXT_COLOR }}>{`И ещё ${rest} — на вкладке «Склад»`}</Typography>}

      <Box>
        <Button
          onClick={openStock}
          disabled={busy}
          fullWidth
          sx={{
            minHeight: 44,
            borderRadius: '10px',
            textTransform: 'none',
            fontSize: '15px',
            fontWeight: 600,
            color: '#fff',
            backgroundColor: `rgba(${ACCENT.rgb},0.18)`,
            '&:hover': { backgroundColor: `rgba(${ACCENT.rgb},0.26)` },
            ...PRESS_SX,
          }}
        >
          Открыть склад
        </Button>
        {error && <Typography role="alert" sx={{ mt: 1, fontSize: '13px', color: NEGATIVE_COLOR }}>{error}</Typography>}
      </Box>
    </Box>
  );
}
